'use client';
import Slider, { Settings, CustomArrowProps } from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { cn } from '@/lib/utils';

import './styles.css';
import { IRegionZoneDictonary } from '@/dictionaries/utils/region-zone/types';
import BlogFeaturedVillagesCard from './Card';
import { BlogRelatedVillage } from '@/types/Blog';

type Props = {
  featuredVillages: BlogRelatedVillage[];
  dict: IRegionZoneDictonary;
  lang: string;
};

function SampleNextArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props;
  return (
    <div
      className={cn(
        'blog-fv-button blog-fv-next-button !flex items-center justify-center',
        className,
      )}
      onClick={onClick}>
      <FiChevronRight className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

function SamplePrevArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props;
  return (
    <div
      className={cn(
        'blog-fv-button blog-fv-prev-button !flex items-center justify-center',
        className,
      )}
      onClick={onClick}>
      <FiChevronLeft className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

const settings: Settings = {
  dots: false,
  infinite: false,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function BlogFeaturedVillagesCarousel({
  featuredVillages,
  dict,
  lang,
}: Props) {
  return (
    <div className="blog-featured-villages-carousel">
      <Slider {...settings}>
        {featuredVillages.map((village, index) => (
          <BlogFeaturedVillagesCard
            key={index}
            featuredVillage={village}
            dict={dict}
            lang={lang}
          />
        ))}
      </Slider>
    </div>
  );
}
